export default __webpack_public_path__ + "static/media/icon-loading-key.35fcf875.svg";